import { render, staticRenderFns } from "./ReportSantamReAward.vue?vue&type=template&id=160e4c1e&"
import script from "./ReportSantamReAward.vue?vue&type=script&lang=js&"
export * from "./ReportSantamReAward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports